import React, { Component } from "react";
import { Plus } from "react-bootstrap-icons";
import { FormControl } from "react-bootstrap";
import "../forms.css";

import type { CreateSubTaskObject } from "../../../redux/tasks/types";
import Task from "../../../models/Task";
import User from "../../../models/User";

type Props = {
  projectId: string,
  user: User,
  task: Task,
  createSubTask: (params: CreateSubTaskObject) => Promise<void>,
  onDidCreateSubTask: (projectId: string) => void,
  onRequestBack: () => void,
  onModalClose: () => void,
};

type State = {
  category: string,
};

export default class SubtaskForm extends Component {
  props: Props;

  state: State = {
    subtask: "",
  };

  createTaskPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  handleSubtaskChange = (event) => {
    this.setState({ subtask: event.target.value });
  };

  handleCreateSubTask = (event) => {
    event.preventDefault();
    this.createTaskPromise = Promise.resolve(this.createSubtask());
  };

  async createSubtask() {
    if (this.state.subtask == "") {
      return;
    }
    const subtask = await this.props.createSubTask({
      details: this.state.subtask,
      project: this.props.task.project,
      parentTask: this.props.task.id,
    });
    this.setState({ subtask: "" });
  }

  render() {
    return (
      <div className="subtask add-subtask">
        <form className="add-subtask-form" onSubmit={this.handleCreateSubTask}>
          <FormControl
            className="strip-textinput-styles subtask-form-input"
            type="text"
            name={"Add Task"}
            placeholder={"+ Add Task"}
            value={this.state.subtask}
            onChange={this.handleSubtaskChange}
          />
          <button className="strip-btn-styles icon-button" type="submit">
            <Plus size="18" />
          </button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/subtask-form/SubtaskForm.js